module.exports = __webpack_public_path__ + "static/img/9.54063ef.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/features_admin/9.png
// module id = ndX3
// module chunks = 0